<template>
    <v-dialog
        :value="checkout"
        @input="!processing && $emit('update:checkout', false)"
        :persistent="processing"
        max-width="350"
        scrollable
        transition="fab-transition"
    >
        <v-form v-model="valid" ref="form" :disabled="processing">
            <v-card :ripple="false" @click="validate">
                <v-card-title class="justify-center primary white--text">Checkout</v-card-title>
                <v-divider />
                <v-card-text class="pb-1">
                    <v-container class="pt-0">
                        <v-row>
                            <v-col cols="12" class="pt-0">
                                <v-text-field
                                    v-model="name"
                                    label="Name*"
                                    name="name"
                                    :prepend-icon="$vuetify.breakpoint.width > 400 ? 'mdi-account' : ''"
                                    class="pt-2"
                                    required
                                    :rules="nameRules"
                                />
                                <v-text-field
                                    v-model="email"
                                    label="Email*"
                                    name="email"
                                    type="email"
                                    :prepend-icon="$vuetify.breakpoint.width > 400 ? 'mdi-email' : ''"
                                    required
                                    :rules="emailRules"
                                />
                                <v-select
                                    v-model="location"
                                    label="Location*"
                                    class="pt-2"
                                    :prepend-icon="$vuetify.breakpoint.width > 400 ? 'mdi-map-marker' : ''"
                                    hint="Where are you situated?"
                                    :items="locations"
                                    :persistent-hint="$vuetify.breakpoint.height > 500"
                                    required
                                    :rules="locationRules"
                                />
                                <v-checkbox
                                    v-model="rememberMe"
                                    dense
                                    label="Remember me for next time!"
                                />
                                <v-checkbox
                                    v-model="saveBasket"
                                    dense
                                    class="my-0"
                                    label="Save my basket!"
                                    hint="We will not empty your basket, so you can repeat this order next time."
                                    :persistent-hint="$vuetify.breakpoint.height > 500"
                                    hide-details="auto"
                                />
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
                <v-divider />
                <v-card-actions ref="cardActions">
                    <v-btn
                        v-if="!processing"
                        color="primary"
                        :disabled="!valid"
                        type="submit"
                        depressed
                        style="width: 100%;"
                        @click="submit"
                    >
                        Order Now
                    </v-btn>
                    <v-progress-circular
                        v-else
                        indeterminate
                        color="primary"
                        class="ma-auto mb-2"
                    />
                </v-card-actions>
            </v-card>
        </v-form>
    </v-dialog>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'DialogCheckout',

  props: {
    checkout: Boolean,
  },

  data: () => ({
    name: '',
    nameRules: [
      (v) => !!v || 'Name is required',
    ],
    email: '',
    emailRules: [
      (v) => !!v || 'Email is required',
      (v) => /.+@.+\..+/.test(v) || 'Email must be valid',
    ],
    location: '',
    locationRules: [
      (v) => !!v || 'Location is required',
    ],
    valid: true,
    rememberMe: true,
    saveBasket: false,
    processing: false,
    locations: ['Lounge', 'Hall', 'Outside'],
  }),

  watch: {
    async checkout(newValue) {
      if (newValue) {
        await this.$nextTick();
        this.$refs.form.resetValidation();
      }
    },
  },

  created() {
    this.name = this.$store.state.basket.orderName.name;
    this.email = this.$store.state.basket.orderName.email;
    this.location = this.$store.state.basket.orderName.location;
    this.rememberMe = !!this.name;
    this.saveBasket = this.$store.state.basket.saveBasket;
  },

  methods: {
    async submit() {
      const valid = this.$refs.form.validate();

      if (!valid) {
        return;
      }

      this.processing = true;
      try {
        await this.placeOrder({
          name: this.name,
          email: this.email,
          location: this.location,
          saveBasket: this.saveBasket,
          rememberMe: this.rememberMe,
        });

        this.$emit('update:checkout', false);

        // await this.$router.push({ name: 'the-menu' });
      } catch (err) {} finally {
        this.processing = false;
      }
    },

    validate(e) {
      if (this.valid) {
        return;
      }

      if (Object.is(this.$refs.cardActions, e.target)) {
        this.$refs.form.resetValidation();
        setTimeout(() => {
          this.$refs.form.validate();
        }, 100);
      }
    },

    ...mapActions(['placeOrder']),
  },
};
</script>

<style scoped>
  .v-card--link:focus::before {
    opacity: 0 !important;
  }
</style>
